import { apiClient } from './client'
import type { TokenPricesResponse } from '../types/tokenMarket'

export const tokenMarketApi = {
  getPrices: () => apiClient.get<TokenPricesResponse>('/api/token-prices'),
}
